// improting the icons to e used from Lucide library
import {
  RefreshCw,		// Refresh
  PlusCircle,		// new 
  HelpCircle,		// help
  DollarSign,		// contribute
  Settings,		// preferences
  LogOut,		// Logout
  Eye,			// view
  Pencil,		// edit
  Trash2,		// delete
  Sunrise,		// activate
  Moon,			// snooze
//  Upload,		// upload (for file save)
  FileUp,		// upload new file
  UserRoundPlus,// add new user contact
  BarChart2,		// dashboard tab
  CalendarCheck2,	// Jon Applications tab
  Users,		// networking
  Building2,		// target companies
  CalendarClock,	// events
  ClipboardList,	// action items
  GraduationCap,	// continued learning
} from 'lucide-react';

// Lucide didnt have a link-new, so created a custom-link-plus
const CustomLinkPlus = ({ size=24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-link-icon lucide-link"
  >
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
    <path d="M19 16v6"/>
    <path d="M22 19h-6"/>
  </svg>
) ;


const IconMap = {
  refresh: RefreshCw,			// Refresh
  create: PlusCircle,			// new 
  help: HelpCircle,			// help
  contribute: DollarSign,		// contribute
  preferences: Settings,		// preferences
  logout: LogOut,			// Logout
  viewRecord: Eye,			// view record
  updateRecord: Pencil,			// edit record
  deleteRecord: Trash2, 		// delete record
  snoozeRecord: Moon,			// snooze record
  activateRecord: Sunrise,		// activate record
//  uploadFile: Upload,			// upload (for file save)
  upLoadNewFile: FileUp,		//upload new file
  addNewUrl: CustomLinkPlus,		// add a new UserRoundPlus
  addContact: UserRoundPlus,		// add a contact
  dashboard: BarChart2,			// dashboard tab
  jobApplications: CalendarCheck2,	// Job Applications tab
  networking: Users,			// networking
  targetCompanies: Building2,		// target companies
  events: CalendarClock,		// events
  actionItems: ClipboardList,		// action items
  learning: GraduationCap,		// continued learning
}

export const Icon = (key, size=18) => {
  const Icon = IconMap[key] ;
  return Icon ? <Icon size={size} /> : null ;
}
